document.addEventListener('DOMContentLoaded', () => {
  const collectionTabs = document.querySelectorAll('.collection-tabs');

  collectionTabs.forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    if (tabs.length === 0 || panels.length === 0) return;

    const activateTab = (newTab) => {
      tabs.forEach((tab) => {
        const isSelected = tab === newTab;
        tab.setAttribute('aria-selected', isSelected);
        tab.classList.toggle('active', isSelected);
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const controlsId = newTab.getAttribute('aria-controls');
        const isVisible = panel.id === controlsId;
        panel.classList.toggle('active', isVisible);
        panel.hidden = !isVisible;
      });

      // 👉 Scroll clicked tab into view (only inside this root)
      newTab.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });

      newTab.focus();
    };

    // Click events
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
    });

    // Keyboard navigation
    tabs.forEach((tab) => {
      tab.addEventListener('keydown', (event) => {
        const tabArray = Array.from(tabs);
        const currentIndex = tabArray.indexOf(tab);

        switch (event.key) {
          case 'ArrowLeft': {
            event.preventDefault();
            const prevTab = tabArray[currentIndex - 1] || tabArray[tabArray.length - 1];
            activateTab(prevTab);
            prevTab.focus();
            break;
          }
          case 'ArrowRight': {
            event.preventDefault();
            const nextTab = tabArray[currentIndex + 1] || tabArray[0];
            activateTab(nextTab);
            nextTab.focus();
            break;
          }
          case 'Home':
            event.preventDefault();
            activateTab(tabArray[0]);
            tabArray[0].focus();
            break;
          case 'End':
            event.preventDefault();
            activateTab(tabArray[tabArray.length - 1]);
            tabArray[tabArray.length - 1].focus();
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            activateTab(tab);
            break;
        }
      });
    });
  });
});
